import React, { useState } from "react"
import { useNavigate } from "react-router-dom"
import { Typography, TextField, Button, Snackbar, Alert } from "@mui/material"
import api from "../utils/api"

export function CreateEventForm() {
  // State for the form fields
  const [eventName, setEventName] = useState("")
  const [eventDescription, setEventDescription] = useState("")
  const [startDate, setStartDate] = useState("")
  const [endDate, setEndDate] = useState("")
  const [numVoters, setNumVoters] = useState(1)
  const [archiveStatus, setArchiveStatus] = useState(false)
  const [openSnackbar, setOpenSnackbar] = useState(false)
  const [errorMessage, setErrorMessage] = useState("")

  const navigate = useNavigate()

  const handleSnackbarClose = () => setOpenSnackbar(false)

  const handleSubmit = async () => {
    const currentDateTime = new Date()

    if (!eventName || !startDate || !endDate || !numVoters) {
      setErrorMessage("All fields are required")
      setOpenSnackbar(true)
      return
    }

    if (numVoters > 1000) {
      setErrorMessage("Voter Limit Maximum is 1000")
      setOpenSnackbar(true)
      return
    }

    const startDateObj = new Date(startDate)
    const endDateObj = new Date(endDate)
    if (startDateObj > currentDateTime) {
      if (startDateObj < endDateObj) {
        // Prepare JSON data
        const eventData = {
          name: eventName,
          description: eventDescription,
          startDate: startDate,
          endDate: endDate,
          numVoters: numVoters,
          archiveStatus: archiveStatus,
        }

        // Send JSON data
        try {
          await api.post("/admin/events", eventData, {
            headers: {
              "Content-Type": "application/json",
            },
          })

          navigate("/admin/dashboard", {
            state: { notification: "Event successfully created!" },
          })
        } catch (error) {
          let message = error.message || "An unexpected error occurred"
          if (error.response) {
            message =
              error.response.data?.message || "An error occurred on the server"
          } else if (error.request) {
            message = "The request was made but no response was received"
          }
          console.error("Error:", message)
          setErrorMessage(message)
          setOpenSnackbar(true)
        }
      } else {
        setErrorMessage("End date can not be in the past.")
        setOpenSnackbar(true)
        return
      }
    } else {
      setErrorMessage("Start date can not be in the past.")
      setOpenSnackbar(true)
    }
  }

  return (
    <>
      <Typography variant="h6">Create New Event</Typography>
      <TextField
        label="Event Name"
        variant="outlined"
        fullWidth
        margin="normal"
        value={eventName}
        required
        onChange={(e) => setEventName(e.target.value)}
      />
      <TextField
        label="Event Description"
        variant="outlined"
        fullWidth
        margin="normal"
        value={eventDescription}
        required
        onChange={(e) => setEventDescription(e.target.value)}
      />
      <TextField
        label="Number of Voters"
        type="number"
        variant="outlined"
        fullWidth
        margin="normal"
        value={numVoters}
        required
        onChange={(e) => setNumVoters(parseInt(e.target.value, 10))}
      />
      <TextField
        label="Start Date"
        type="datetime-local"
        variant="outlined"
        fullWidth
        margin="normal"
        value={startDate}
        required
        onChange={(e) => setStartDate(e.target.value)}
        InputLabelProps={{ shrink: true }}
      />
      <TextField
        label="End Date"
        type="datetime-local"
        variant="outlined"
        fullWidth
        margin="normal"
        value={endDate}
        required
        onChange={(e) => setEndDate(e.target.value)}
        InputLabelProps={{ shrink: true }}
      />
      <Button
        variant="contained"
        color="primary"
        fullWidth
        style={{ marginBottom: "15px" }}
        onClick={handleSubmit}
      >
        Create Event
      </Button>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity="error"
          sx={{ width: "100%" }}
        >
          {errorMessage}
        </Alert>
      </Snackbar>
    </>
  )
}
